import { useSecaoEquipe } from "./use-secao-equipe";
import { SecaoEquipeView } from "./view-secao-equipe";
import type { SecaoEquipeProps } from "./types-secao-equipe";

export function SecaoEquipe(props: SecaoEquipeProps) {
  const vm = useSecaoEquipe(props);

  return <SecaoEquipeView {...props} {...vm} />;
}

export type * from "./types-secao-equipe";
